import { useEffect, useState } from "react"
import { getEmpresasById,patchEmpresas,postEmpresas} from "../../services/EmpresaServices"
import { EmpresaFormContext} from "./EmpresaContext"
import { useNavigate, useParams } from 'react-router-dom';
//import { Color } from '../../routes/RoutesConstants'

export const EmpresaFormState = ({ children }) => {
    const [report, setReport] = useState(null)
    const [id, setId] = useState(null)
    const navigate = useNavigate();
    //const { id } = useParams()
    

    useEffect(() => {
        getEmpresaByIdData(1)
    }, [])

    const getEmpresaByIdData = async (id) => {
        let res = await getEmpresasById(id)
        if (res) {
            setReport(res)
            setId(res.id)
        }
    }

    const postEmpresaData = async (body) => {
        const res = await postEmpresas(body)
        if (res) navigate("/");
    }

    const patchEmpresaData = async (id, body) => {
        const res = await patchEmpresas(id, body)
        if (res) navigate("/");
    }

    return <EmpresaFormContext.Provider value={{
        report,
        postEmpresaData,
        patchEmpresaData,
        getEmpresaByIdData,
        id
    }} >
        {children}
    </EmpresaFormContext.Provider>
}